var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.menuVisible,
          expression: "menuVisible",
        },
      ],
      staticClass: "menu",
      attrs: { id: "contextmenu" },
    },
    [
      _vm.configData.type === 1
        ? _c(
            "div",
            { staticClass: "right-item-list" },
            [
              _vm.configData.data.type !== 1
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.fileDownLoad(_vm.configData.data)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("public.download")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(8)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.configData.data.is_collect === 0
                          ? _vm.$t("file.collection")
                          : _vm.$t("file.cancelcollection")
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.configData.type === 2
        ? _c(
            "div",
            { staticClass: "right-item-list" },
            [
              _vm.configData.data.type === 1
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(1)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.configData.data.is_shortcut === 0
                              ? _vm.$t("file.setcommon")
                              : _vm.$t("file.cancelcommon")
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.data.type !== 1
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.fileDownLoad(_vm.configData.data)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("public.download")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(8)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.configData.data.is_collect === 0
                          ? _vm.$t("file.collection")
                          : _vm.$t("file.cancelcollection")
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.configData.type === 3
        ? _c(
            "div",
            { staticClass: "right-item-list" },
            [
              _vm.configData.share == 2
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.fileDownLoad(_vm.item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("public.download")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.share == 1 &&
              _vm.configData.data.auth.download === 1
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.fileDownLoad(_vm.item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("public.download")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.share == 1 &&
              _vm.configData.data.auth.download === 1
                ? _c("el-divider")
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.share == 2
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(1)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("file.sharingsettings")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.share == 2
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(2)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("file.cancelsharing")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.share == 2 ? _c("el-divider") : _vm._e(),
              _vm._v(" "),
              _vm.configData.share == 2
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(3)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("public.delete")))]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.configData.type === 4 || _vm.configData.type === 5
        ? _c(
            "div",
            { staticClass: "right-item-list" },
            [
              _vm.configData.data.type === 1
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(1)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.configData.data.is_shortcut === 0
                              ? _vm.$t("file.setcommon")
                              : _vm.$t("file.cancelcommon")
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.data.type !== 1
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.fileDownLoad(_vm.configData.data)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("public.download")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _vm.configData.data.type !== 1 &&
              _vm.fileIsImage(_vm.configData.data.file_type)
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(7)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.configData.data.is_share === 0
                              ? "共享"
                              : "取消共享"
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(8)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.configData.data.is_collect === 0
                          ? _vm.$t("file.collection")
                          : _vm.$t("file.cancelcollection")
                      ) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("file.moveto")))]
              ),
              _vm._v(" "),
              _vm.configData.data.type !== 1
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(3)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("file.copyto")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(4)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("file.rename")))]
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(6)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("public.delete")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(5)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("file.attribute")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.configData.type === 6
        ? _c(
            "div",
            { staticClass: "right-item-list" },
            [
              ["docx", "xlsx", "pdf"].includes(_vm.configData.data.file_ext)
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(1)
                        },
                      },
                    },
                    [_vm._v("\n      打开\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.data.type !== 1
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.fileDownLoad(_vm.configData.data)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("public.download")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.data.type !== 1
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(10)
                        },
                      },
                    },
                    [_vm._v("分享")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.data.type !== 1 ? _c("el-divider") : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("file.moveto")))]
              ),
              _vm._v(" "),
              _vm.configData.data.type === 1 &&
              _vm.configData.data.user_id === _vm.$store.state.user.userInfo.id
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(9)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.$t("file.directory")) + "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.configData.data.type !== 1
                ? _c(
                    "div",
                    {
                      staticClass: "right-item",
                      on: {
                        click: function ($event) {
                          return _vm.rightItemClick(3)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("file.copyto")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(4)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("file.rename")))]
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(6)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("public.delete")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right-item",
                  on: {
                    click: function ($event) {
                      return _vm.rightItemClick(5)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("file.attribute")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.configData.type === 7
        ? _c("div", { staticClass: "right-item-list" }, [
            _c(
              "div",
              {
                staticClass: "right-item",
                on: {
                  click: function ($event) {
                    return _vm.rightItemClick(2)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("file.completelydelete")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "right-item",
                on: {
                  click: function ($event) {
                    return _vm.rightItemClick(1)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("file.restorefile")))]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }